import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { HttpGenericService } from 'src/app/services/http-generic.service';
import { SweetAlertService } from 'src/app/services/sweet-alert.service';
import { TipoDeMensajeSwal } from 'src/app/models/enums/tipo-de-mensaje-swal';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-proveedor-detalle',
  templateUrl: './proveedor-detalle.component.html',
  styleUrls: ['./proveedor-detalle.component.css']
})
export class ProveedorDetalleComponent {

  proveedor: any;
  docsVersionActual = [];
  docsVersionesAnteriores = [];
  mostrarDocsVersionesAnteriores = false;
  procesando: boolean = false;


  constructor(
    public bsModalRef: BsModalRef, 
    private httpGenerico: HttpGenericService, 
    private swal: SweetAlertService,
    private auth: AuthService) { }

  inicializarDatos() {
    if (this.proveedor) {
      let versiones = this.proveedor.documentos.map(d => d.version);
      let versionActual = Math.max(...versiones);
      
      this.docsVersionActual = this.proveedor.documentos.filter(d => d.version === versionActual);
      this.docsVersionesAnteriores = this.proveedor.documentos.filter(d => d.version < versionActual);
    }
  }

  onMostrarDocsVersionesAnteriores() {
    this.mostrarDocsVersionesAnteriores = !this.mostrarDocsVersionesAnteriores;
  }

  convertBytesToMb(value) {
    return value / Math.pow(1024, 2);
  }

  cambiarEstado(estado: boolean) {
    this.procesando = true;
    let modelo = {
      idUsuario: this.auth.obtenerSesionUsuario().sessionId,
      idTercero: this.proveedor.idTercero,
      estado: estado
    };

    this.httpGenerico.post('proveedores/estados',modelo)
      .subscribe(data => {
        this.procesando = false;
        this.swal.mostrar(TipoDeMensajeSwal.Success, data.mensaje, '');
        this.bsModalRef.content.recargar = true;
        this.bsModalRef.hide();
      }, err => {
        this.procesando = false;
        this.swal.mostrar(TipoDeMensajeSwal.Error, 'Ha ocurrido un error, intentelo mas tarde', '');
      });
  }

  calificarDocumento(id: number, estado: boolean){
    let modelo = {
      idDocumentoProveedor: id,
      cumple: estado,
    }

    this.httpGenerico.post('evaluacionproveedores',modelo)
      .subscribe(data => {
        this.swal.mostrar(TipoDeMensajeSwal.Success, 'Calificación exitosa', '');
      }, err => {
        this.swal.mostrar(TipoDeMensajeSwal.Error, 'Ha ocurrido un error, intentelo mas tarde', '');
      });
  }

}
